const state = () => ({
  show_modal:null,
  modalcontent:null,
  editing_translation:null,
});
const getters = {
  show_modal(state){
    return state.show_modal
  },
  modalcontent(state){
    return state.modalcontent
  },
  editing_translation(state){
    return state.editing_translation
  },
};
const  mutations =  {
  SET_SHOW_MODAL(state,data){
    state.show_modal = data
  },
  SET_MODAL_CONTENT(state,data){
    state.modalcontent = data
  },
  SET_EDITING_TRANSLATION(state,data){
    state.editing_translation = data
  },
};
const actions =  {
  setShowModal({commit},data)  {
    commit("SET_SHOW_MODAL",data)
  },
  setModalContent({commit},data)  {
    commit("SET_MODAL_CONTENT",data)
  },
  setEditingTranslation({commit},data)  {
    commit("SET_EDITING_TRANSLATION",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

